import "@hotwired/turbo-rails"
import "./night_warrior/bootstrap_setup"
import "./night_warrior/night-warrior"
import "./controllers"

document.addEventListener("turbo:load", () => {
  document.body.classList.add("nw-page-enter")
})
